module.exports = "https://cdn-skillquest.mathletics.com/app/184/assets/images/1a7e3f18796235f4b72ef0b5cca79d7f.svg";